<template>
  <div>
	<dl v-if="!json.init" class="spe-recommend-goods"
      id="mallRecommendGoods"
      ref="speRecommendGoods"
      :style="commonStyle"
      :ddt-area="`component_${json.floorId}_推荐商品组件`"
      :floor-expose="`${jdata.pageTrace}#perm_id=${perm_id}#client=${client}`"
      ddt-expose="on"
    >
    <dd class="p_margin p_module" 
		  :product-click="`${jdata.pageTrace}#reco_pid=0#main_pid=1#perm_id=${perm_id}#client=${client}`"
		>
		<transition-group name="fade" class="animate-fade " :class="{ column_type_1: json.compStyle == 1, column_type_2: json.compStyle == 2 }">
		  <div class="p_box" v-for="(el, index) in jdata.products" :key="el.productId" :el="el">
          <div
            class="product p_margin"
            @click="$sys.dict.href(el.link)"
            :product-click="`${el.itemTraceReco}#reco_pid=${el.productId}#main_pid=0#perm_id=${perm_id}#client=${client}`"
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_推荐商品组件.商品${el.productId}_点击跳转`"
            :data-desc="el.title"
            :dd_name="`${pt()}.component_${json.floorId}_推荐商品组件.商品${el.productId}_点击跳转.${el.title}`"
            :ddt-click="`${pt()}.component_${json.floorId}_推荐商品组件.商品${el.productId}_点击跳转.${el.title}`"
            :ddt-pit="`商品${el.productId}_点击跳转`"
            :ddt-src="el.title"
            ddt-expose="on"
          >
            <img class="img" v-lazy="el.imgUrl" />
            <h2 class="line2" v-show="el.title">{{ el.title }}</h2>
            <div class="labels" >
              <span v-for="(la, i) in el.labels" :key="i" class="la" :class="'label' + (la.type || 0)">{{ la.name | label_filter }}</span>
            </div>
            <div class="price" v-if="el.salePrice || el.discount || el.originalPrice">
              <div class="l">
                <div class="salePrice" v-if="el.salePrice"><i>¥</i>{{ el.salePrice }}</div>
              </div>
            </div>
          </div>
      </div>
    </transition-group>
    </dd>
  </dl>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import * as sys from "../assets/js/index";

export default {
	name: "speRecommendGoods",
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {
      products:[1,2,3,4,5],
      perm_id: '',
      client: ''
    };
	},
  inject: ['pt'],
	computed: {
		jdata() {
			return this.json.data || { commonStyle: {}, header: {} };
		},
		commonStyle() {
			let sty = {};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
			return sty;
		},
		ddStyle() {
      if(this.jdata.commonStyle.margin > 0){
        let sty = {
          padding: `0 ${this.jdata.commonStyle.margin}px`
        };
        return sty;
      }
		}
	},
	watch: {
  },
  created() {
		let dd_client = sys.cookie.getJSON("DD_client")
	  const query = this.$route.query
	  this.perm_id = query.permanent_id || dd_client.permanent_id || ''
	  this.client = query.ct || query.user_client || dd_client.ct || ''
		
		
		
  },
  mounted() {
    // let cc_conf = { reco_id: "mallRecommendGoods"};
		// console.log(typeof(CC))
    // if (typeof(CC)=='object') {
		// 	console.log('destroy----')
		// 	CC.destroy()
		// 	console.log('cc----')
		// 	CC.cc(cc_conf)
		// }
  },
	methods: {
  },
	filters: {
		label_filter(v) {
			if (v == "当当自营") {
				return "自营";
			}
			return v;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-recommend-goods {
	min-height: 600px;
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100%;
	dt {
		height: 84px;
		background-size: cover;
		display: flex;
		> div {
			padding: 0 40px;
			display: flex;
			align-items: center;
			flex: 1;
			label {
				flex: 1;
				font-size: 34px;
			}
			span {
				font-size: 24px;
			}
		}
	}
	dd {
    flex: 1;
    .animate-fade{
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      padding: 10px 9px;
      box-sizing: border-box;
    }
		.p_box {
			box-sizing: border-box;
			padding-right: 5px;
			overflow: hidden;
			margin-bottom: 10px;
			display: flex;
			.product {
				border-radius: 8px;
				overflow: hidden;
				background: #fff;
				padding-bottom: 20px;
				.img {
					width: 100%;
					
				}
				h2 {
					font-size: 26px;
					color: #141414;
					line-height: 36px;
					margin-top: 12px;
					padding: 0 14px;
					height:72px;
				}
				h3 {
					font-size: 22px;
					color: #828282;
					line-height: 22px;
					margin-top: 12px;
					padding: 0 14px;
					height:22px;
				}
				.labels {
					margin-top: 8px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					height:36px;
					span {
						margin-right: 4px;
						margin-top: 4px;
						flex: 0 0 auto;
					}
					.la:last-of-type {
						margin-right: 0;
					}
				}
				.price {
					margin-top: 16px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					.l {
						flex: 1;
						display: flex;
						align-items: center;
						.salePrice {
							font-family: PingFangSC-Medium;
							font-size: 30px;
							color: #ff463c;
							line-height: 30px;
							i {
								font-size: 22px;
							}
						}
						.discount,
						.originalPrice {
							font-size: 20px;
							color: #828282;
							margin-left: 4px;
						}
					}
					.addcart {
						width: 40px;
						height: 40px;
						border-radius: 100%;
						background: rgba(0, 0, 0, 0.05);
						text-align: center;
						line-height: 40px;
						font-size: 24px;
						color: #141414;
					}
				}
				.ebook {
					margin-top: 12px;
					padding: 0 14px;
					display: flex;
					align-items: center;
					font-size: 20px;
					color: #1cae9b;
					line-height: 20px;
					height:20px;
					img {
						width: 20px;
						height: 20px;
						margin-right: 4px;
					}
				}
				.tuan {
					margin-top: 12px;
					padding: 0 0.14rem;
					height:40px;
					.person {
						display: inline-block;
						font-size: 0.2rem;
						line-height: 0.24rem;
						padding: 0.02rem 0.04rem 0 0.04rem;
						margin-right: 0.08rem;
						color: #ff463c;
						border-radius: 0.04rem;
						border: 0.02rem solid #ff463c;
					}
					.num {
						display: inline-block;
						font-size: 0.22rem;
						line-height: 0.3rem;
						color: #828282;
					}
				}
				.desc {
					margin-top: 26px;
					padding: 0 0.14rem;
					height: 0.7rem;
					line-height: 0.36rem;
					font-size: 0.24rem;
					color: #d0b28f;
				}
			}
		}
	}
	.column_type_1 {

		.p_box {
			flex: 0 0 33.333%;
			padding: 0 5px;
			.product {
				.labels{
          flex-wrap: wrap;
          overflow: hidden;
        }
			}
		}
	}
	.column_type_2 {

		.p_box {
			flex: 0 0 50%;
      padding-right: 5px;
			.product {
				.labels{
          flex-wrap: wrap;
          overflow: hidden;
        }
			}
		}
		.p_box:nth-of-type(2n) {
			padding-right: 0;
			padding-left: 5px;
		}
	}

  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-enter /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fade-enter-to {
    opacity: 1;
  }
}
</style>
